import { ChatMessage } from '../../../messages/models/ChatMessage';
import { RootState } from '../../../../redux/store';
import { selectMessagesBySessionId } from '../../base/chat/selectMessagesBySessionId';
import { selectSelectedSessionId } from '../../base/chat/selectSelectedSessionId';

export const selectSelectedMessages = (state: RootState): ChatMessage[] => {
    const sessionId = selectSelectedSessionId(state);
    if (!sessionId) return [];

    const messagesBySessionId = selectMessagesBySessionId(state);
    return messagesBySessionId[sessionId] ?? [];
};
